import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { SearchCustomerParam } from 'src/app/Models/searchCustomer';
import { TransactionService } from '../../../Services/transaction.service';
import { HttpEventType, HttpClient, HttpHeaderResponse } from '@angular/common/http';

// import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
// import { FormGroup,FormControl,Validators } from '@angular/forms';

@Component({
  selector: 'app-customer-rank-upload',
  templateUrl: './customer-rank-upload.component.html',
  styleUrls: ['./customer-rank-upload.component.css']
})
export class CustomerRankUploadComponent implements OnInit {

  @ViewChild('file') myfileVariable:any;
  public progress: number=0;
  public message: string='';
  selectedPPFileName:string;
  showSpinner:boolean=false;
  Enable:boolean = false;
  
  constructor(private _TransactionService: TransactionService ) { 
    this.selectedPPFileName = "Choose file";
  }

  ngOnInit(): void {
  }


  searchCustomer(SearchCustomerParam: SearchCustomerParam) {

    this.showSpinner = true;
   
    this._TransactionService.GetExcelDocument(SearchCustomerParam).subscribe((d: any) => {
       this.downloadFile((d))
       this.showSpinner = false;
       
    });
  }

     downloadFile(data: any) {
    
     const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
     const url= window.URL.createObjectURL(blob);
     window.open(url);
  }
  
  changePP(event:any){
    if(event){
      if(event.target.files.length >0){
        this.selectedPPFileName = event.target.files[0].name;
      }
    }
}
  uploadFile(files:any) {
   
    if (files.length === 0){
      alert('Please choose a file to upload!')
      return;
    }
       
    
    const formData = new FormData();

     let fileToUpload = <File>files[0];
     var filetype=fileToUpload.type;
      
      if(filetype!='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        alert('Please Upload .xlsx or .xls file');
        this.myfileVariable.nativeElement.value = "";
        this.selectedPPFileName = "";
        this.selectedPPFileName = "Choose file";
        return;
      }
      formData.append('file', fileToUpload, fileToUpload.name);
      this.showSpinner = true;
      this.Enable = true;
      this._TransactionService.ImportExcelDocument(formData).subscribe((event: any) => {
   
      var dataView = new DataView(event);
      var decoder = new TextDecoder('utf8');
      var decodedString = decoder.decode(dataView);
      this.showSpinner = false;
      this.Enable = false;
      if(decodedString=="1"){
       alert('uploaded successfully!!');
     }
     else{
      this.downloadFile(event);
      alert('uploaded successfully!!');
     }
     
      this.myfileVariable.nativeElement.value = "";
      this.selectedPPFileName = "";
      this.selectedPPFileName = "Choose file";
     });
      
}

}

